import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { SignUp } from "../../pages/sign-up/SignUp";

const SignupSearchSchema = z.object({
	plan: z.enum(["bootstrap", "standard", "scale"]).optional(),
	billingPeriod: z.enum(["monthly", "yearly"]).optional(),
});

export const Route = createFileRoute("/auth/signup")({
	validateSearch: SignupSearchSchema,
	head: () => ({
		meta: [{ title: "Sign up - BitEasy" }],
	}),
	component: SignUp,
});
